// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__zd21a","label":"SetPasswdForm_label__YcHgg"};